import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import focusable from '../../components/Focusable/Focusable'
import VideoItemThumb from '../VideoItem/VideoItemThumb'
import VideoItemCaption from '../VideoItem/VideoItemCaption'
import {
  getFormattedOrdinals,
  secondsToHms,
  secondsToTTS,
  getTitleAndSubtitle,
  triggerSentryError,
} from '../../../../shared/helpers.js'
import tts from '../../lib/TTS'

export class CarouselItem extends React.Component {
  constructor(props) {
    super(props)

    this.componentType = 'carouselItem'
    this.carouselLinkRef = React.createRef()
  }

  getUrl(content, slug, parentTitle) {
    if (content.item_type === 'show') {
      return `/show-details/${content.slug}`
    } else if (content.item_type === 'video') {
      return `/video-details/${encodeURIComponent(content.url)}?availability=${
        content.availability
      }`
    } else if (content.item_type === 'season') {
      return `/seasons/${slug}/?type=all&season=${content.ordinal}&parent=${parentTitle}`
    } else if (content.item_type === 'skylab-collection') {
      return `/collections/${encodeURIComponent(content.url)}`
    } else {
      return `#`
    }
  }

  onKeyEvent(key) {
    let handled = false

    if ('ENTER' === key) {
      if (this.props.carouselSlug === 'popular-shows') {
        /* window.ga('send', {
          hitType: 'event',
          eventCategory: 'Search',
          eventAction: this.props.carouselTitle,
          eventLabel: this.props.content.title,
        }) */
      }
      this.carouselLinkRef.current?.click()
    }

    return handled
  }

  getShowPoster(images) {
    let image = ''
    if (images) {
      if (images['show-poster2x3']) {
        image = `${images['show-poster2x3']}?resize=260x390&format=webp`
      } else {
        image = ''
      }
    }

    return image
  }

  getImageUrl(images, itemType) {
    let imageUrl = ''
    let assetMezzanine

    if (images) {
      if (itemType === 'season' && images['season-mezzanine-16x9']) {
        assetMezzanine = images['season-mezzanine-16x9']
      } else if (
        itemType === 'skylab-collection' &&
        images['collection-mezzanine-16x9']
      ) {
        assetMezzanine = images['collection-mezzanine-16x9']
      } else {
        assetMezzanine =
          images['asset-mezzanine-16x9'] || images['asset-kids-mezzanine1-16x9']
      }
    } else {
      assetMezzanine = null
    }

    switch (itemType) {
      case 'video':
      case 'season':
        if (images) {
          imageUrl = assetMezzanine
            ? `${assetMezzanine}?resize=487x274&format=webp`
            : ''
        }
        break
      case 'skylab-collection':
      case 'showcase':
        if (images) {
          imageUrl = assetMezzanine
            ? `${assetMezzanine}?resize=633x356&format=webp`
            : ''
        }
        break

      case 'show':
        imageUrl = this.getShowPoster(images)
        break

      default:
        if (images && assetMezzanine) {
          imageUrl = `${assetMezzanine}?crop=864x486&format=webp`
        } else {
          imageUrl = ''
        }
        break
    }
    return imageUrl
  }

  getItemClass(itemType) {
    const videoStyle = {
      width: '488px',
      height: '256px',
      color: 'white',
      marginRight: '55px',
      position: 'relative',
      display: 'inline-block',
    }

    const showStyle = {
      width: '260px',
      height: '392px',
      marginRight: '55px',
      position: 'relative',
      display: 'inline-block',
    }

    const showcaseStyle = {
      width: '632px',
      height: '356px',
      marginRight: '55px',
      position: 'relative',
      display: 'inline-block',
    }
    let itemClassStyle

    switch (itemType) {
      case 'video':
      case 'season':
      case 'skylab-collection':
        itemClassStyle = videoStyle
        break

      case 'showcase':
        itemClassStyle = showcaseStyle
        break

      case 'show':
        itemClassStyle = showStyle
        break

      default:
        itemClassStyle = videoStyle
    }
    return itemClassStyle
  }

  readText() {
    const { view, index, itemCount, content, hideMetaData } = this.props

    try {
      if (view === 'season') {
        tts.addTextToRead([
          `${index + 1} of ${itemCount}`,
          `Season ${content?.ordinal}`,
        ])
      } else {
        const { showTitle, episodeTitle } = getTitleAndSubtitle(content)
        if (view === 'show') {
          tts.addTextToRead([`${index + 1} of ${itemCount}`, showTitle])
        } else {
          const formattedOrdinals = getFormattedOrdinals(content)
          if (hideMetaData) {
            tts.addTextToRead([
              `${index + 1} of ${itemCount}`,
              showTitle,
              episodeTitle,
            ])
          } else {
            tts.addTextToRead([
              `${index + 1} of ${itemCount}`,
              episodeTitle,
              formattedOrdinals,
              secondsToTTS(`${content?.duration}`),
            ])
          }
        }
      }
    } catch (err) {
      triggerSentryError('readText', 'CarouselItem.js', {
        errorMessage: err.message ?? 'Undefined error message (default)',
        errorLocation: 'CarouselItem - readText',
      })
    }
  }

  render() {
    const {
      content,
      emptySet,
      hideMetaData,
      hideTitle,
      parentTitle,
      slug,
      view,
    } = this.props
    const url = this.getUrl(content, slug, parentTitle)
    const imageUrl = this.getImageUrl(content.images, view)
    const itemClass = this.getItemClass(view)
    return (
      <Link to={url} style={itemClass} ref={this.carouselLinkRef}>
        {content && (
          <>
            <VideoItemThumb
              emptySet={emptySet}
              focus={this.props.hasFocus}
              thumb={imageUrl}
              itemType={view}
              currentlyWatched={content.seconds_watched}
              videoLength={content.duration}
              title={content.title}
              index={this.props.index}
              is_mvod={content.flags ? content.flags.is_mvod : false}
            />
            <VideoItemCaption
              content={content}
              hasFocus={this.props.hasFocus}
              hideMetaData={hideMetaData}
              hideTitle={hideTitle}
              view={view}
              duration={secondsToHms(content.duration)}
              videoType={content.video_type}
            />
          </>
        )}
      </Link>
    )
  }
}

CarouselItem.propTypes = {
  carouselTitle: PropTypes.string,
  carouselSlug: PropTypes.string,
  content: PropTypes.shape({
    duration: PropTypes.number,
    flags: PropTypes.shape({
      is_mvod: PropTypes.bool,
    }),
    images: PropTypes.object,
    item_type: PropTypes.string,
    ordinal: PropTypes.number,
    seconds_watched: PropTypes.number,
    slug: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    video_type: PropTypes.string,
  }),
  hasFocus: PropTypes.bool,
  hideMetaData: PropTypes.bool,
  hideTitle: PropTypes.bool,
  index: PropTypes.number,
  itemCount: PropTypes.number,
  parentTitle: PropTypes.string,
  hasRecentlyWatched: PropTypes.bool,
  slug: PropTypes.string,
  view: PropTypes.string,
  emptySet: PropTypes.bool,
}

export default focusable(CarouselItem)
